"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Application = _interopRequireDefault(require("pricing-pages-unified-ui/containers/Application"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _FreeToolsPage = _interopRequireDefault(require("./components/free-tools-page/FreeToolsPage"));

var _BundlePage = _interopRequireDefault(require("./components/bundle-page/BundlePage"));

var _SalesHubPage = _interopRequireDefault(require("./components/SalesHubPage"));

var _MarketingHubPage = _interopRequireDefault(require("./components/MarketingHubPage"));

var _ServiceHubPage = _interopRequireDefault(require("./components/ServiceHubPage"));

var _GrowthSuitePage = _interopRequireDefault(require("./components/growth-suite-page/GrowthSuitePage"));

var _ErrorPage = _interopRequireDefault(require("./components/ErrorPage"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _CmsHubPage = _interopRequireDefault(require("pricing-pages-unified-ui/components/cms-hub-page/CmsHubPage"));

var ConstantsTest = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: "test-chunk" */
    'pricing-pages-unified-ui/components/ConstantsTest');
  },
  LoadingComponent: function LoadingComponent() {
    return null;
  }
});
var ContactsConfirmationPage = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: "contacts-confirmation" */
    'pricing-pages-unified-ui/components/contacts-confirmation-page/ContactsConfirmationPage');
  },
  LoadingComponent: function LoadingComponent() {
    return null;
  }
});
var SuiteContactsConfirmationPage = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: "contacts-confirmation" */
    'pricing-pages-unified-ui/components/contacts-confirmation-page/traditional-hub/SuiteContactsConfirmationPage');
  },
  LoadingComponent: function LoadingComponent() {
    return null;
  }
});

function Routes(_ref) {
  var defaultRoute = _ref.defaultRoute;
  return _react.default.createElement(_Application.default, null, _react.default.createElement(_reactRouterDom.Switch, null, _react.default.createElement(_reactRouterDom.Route, {
    path: "/crm",
    component: _FreeToolsPage.default
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: "/bundle",
    component: _BundlePage.default
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: "/confirm-contacts",
    component: ContactsConfirmationPage
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: "/confirm-suite-contacts",
    component: SuiteContactsConfirmationPage
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: "/legacy-starter-confirmation"
  }, _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/legacy-starter-sidegrade-page/SidegradeWarningPage");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/ErrorPage");
    }
  })), _react.default.createElement(_reactRouterDom.Route, {
    path: "/contact-sales"
  }, _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/ErrorPage");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      'pricing-pages-unified-ui/components/contact-sales-page/ContactSalesPage');
    },
    authedComponentProps: {},
    publicComponentProps: {}
  })), _react.default.createElement(_reactRouterDom.Route, {
    path: "/sales",
    component: _SalesHubPage.default
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: "/service",
    component: _ServiceHubPage.default
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: "/cms",
    component: _CmsHubPage.default
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: "/growth-suite",
    component: _GrowthSuitePage.default
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: "/marketing",
    component: _MarketingHubPage.default
  }), _react.default.createElement(_reactRouterDom.Redirect, {
    from: "/",
    exact: true,
    to: defaultRoute
  }), _react.default.createElement(_reactRouterDom.Route, {
    path: "/_constants-test"
  }, _react.default.createElement(ConstantsTest, null)), _react.default.createElement(_reactRouterDom.Route, {
    component: _ErrorPage.default
  })));
}

var _default = Routes;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/Routes.js
// module id = 559
// module chunks = 5 6